import { createModel } from "@rematch/core";
import * as _ from "lodash";
import { UserState } from "src/types";
import IUserRequestType from "src/types/UserRequestType";
import IUserResponseType from "src/types/UserResponseType";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, signoutIfUnauthorized } from "./utilities";

const initialState: UserState = [];

export const users = createModel<RootModel>()({
  state: initialState as UserState,
  reducers: {
    createSuccess(state, payload: IUserResponseType) {
      return [...state, payload];
    },
    updateSuccess(state, payload: IUserResponseType) {
      return _.orderBy(
        [..._.reject(state, (user) => user.id === payload.id), payload],
        "id"
      );
    },
    deleteSuccess(state, payload: IUserRequestType) {
      return [..._.reject(state, (user) => user.id === payload.id)];
    },
    fetchSuccess(state, payload: IUserResponseType[]) {
      return [...payload];
    },
    actionFail(state) {
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async fetchUsers(payload: null, rootState) {
      const token = checkToken(rootState, () => dispatch.users.actionFail());
      if (!token) return;

      try {
        const usersResult = await api.fetchUserData(token);
        dispatch.users.fetchSuccess(usersResult);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.users.actionFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
    async updateUser(user: IUserRequestType, rootState) {
      const token = checkToken(rootState, () => dispatch.users.actionFail());
      if (!token) return;

      try {
        const updateUserResult = await api.updateUser(token, user);
        dispatch.users.updateSuccess(updateUserResult);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.users.actionFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
    async createUser(user: IUserRequestType, rootState) {
      const token = checkToken(rootState, () => dispatch.users.actionFail());
      if (!token) return;

      try {
        const createUserResult = await api.createUser(token, user);
        dispatch.users.createSuccess(createUserResult);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.users.actionFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
    async deleteUser(user: IUserRequestType, rootState) {
      const token = checkToken(rootState, () => dispatch.users.actionFail());
      if (!token) return;

      try {
        await api.deleteUser(token, user);
        dispatch.users.deleteSuccess(user);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.users.actionFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/users.ts